export enum TfaType {
  OTP = 'OTP',
}
